module.exports = __webpack_public_path__ + "assets/img/dzh-19.8456cc5a.jpg";